import React from 'react';
import { sideNav } from '@/utils/translations';

interface ApprovalRequiredBadgeProps {
  count: number;
}

/**
 * Small red count pill shown next to a "Payments" nav item once payments are awaiting approval -
 * shared between the v2 topbar (PaymentsMenu) and the v3 sidebar (SideNavBar) so the two versions
 * can't visually drift apart on what's meant to be an identical indicator. Renders nothing at 0 -
 * there's no Figma "0 state" for this badge.
 */
const ApprovalRequiredBadge: React.FC<ApprovalRequiredBadgeProps> = ({ count }) => {
  if (count <= 0) return null;

  return (
    <span
      aria-label={sideNav.paymentsApprovalRequiredLabel(count)}
      className="flex h-4 min-w-[16px] flex-shrink-0 items-center justify-center rounded-full bg-error-darkred px-1 text-[8px] font-medium leading-none text-white">
      {count}
    </span>
  );
};

export default ApprovalRequiredBadge;
